// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"fzFjMv5PM9V+laQDloOkqg=="};